import './search-featured-card.scss'

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faDotCircle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from 'vue'

import { SearchFeatured, SearchResult } from '@skinsoft/types'
import { getReadableDate } from '@skinsoft/utils'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { States } from '@skinsoft/ui'

import { Author } from '../item-card/description/author'
import { Media } from '../item-card/media'
import { Touchable } from '../touchable'

export const SEARCH_FEATURED_CARD_TITLE_CLICKED = 'search-featured-card-title-clicked'

export const SearchFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAuthor: Author,
        sMedia: Media,
        sTouchable: Touchable,
    },
    props: ['searchFeatured', 'rounded', 'targetRouteName', 'hasLastReport', 'titleClickAction'],
    template: require('./search-featured-card.html'),
    data() {
        return {
            loadingIcon: faCircleNotch,
            editIcon: faExternalLinkAlt,

            circleIcon: faDotCircle,
            state: States.PENDING as States,

            // Item data
            authorFunction: '',
            searchresult: null as any as SearchResult,
        }
    },
    computed: {
        shouldDisplayAuthorFunction(): boolean {
            const credits = this.searchFeatured.credits
            return !!credits && !!credits.alias && !!credits.authorFunction
        },
        lastReportDate() {
            return getReadableDate(this.searchFeatured.lastDateOfConditionReport)
        },
    },
    watch: {
        searchFeatured: {
            handler(searchFeatured: SearchFeatured) {
                this.state = searchFeatured ? States.READY : States.PENDING
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        isReady() {
            return this.state === States.READY
        },
        onTitleClicked() {
            if (this.titleClickAction) {
                this.$emit(SEARCH_FEATURED_CARD_TITLE_CLICKED)
            }
        },
    },
})
